import {
  Button,
  Card,
  Col,
  Form,
  Image,
  Input,
  Layout,
  Modal,
  Row,
  Spin,
  message,
} from 'antd';
import React, { useEffect, useState } from 'react';
import routes from '../../../controller/Routes';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getCandidateToken,
  setCandidateLogo,
  setCandidateToken,
} from '../../../controller/localStroageHandler';
import { RightOutlined } from "@ant-design/icons";
import { getLogo } from '../../../controller/api/globalServices';
import { otpVarify } from '../../../controller/api/candidateServices'
import { exitFullScreen, goFullScreen } from '../../../controller/Fullscreen';
import { site_key } from '../../../controller/enum';
import ReCAPTCHA from 'react-google-recaptcha';
const { Header, Content } = Layout;
const CandidateLogin = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [logo, setLogo] = useState('');
  const [organizationName, setorganizationName] = useState("")
  const [device, setDevice] = useState(false)
  const [captchaValue, setCaptchaValue] = useState(null);
  const enterOnlyNumber = (event) => {
    const keyCode = event.which || event.keyCode;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp('[0-9]').test(keyValue);
    // const isValidecimal = new RegExp(".").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };
  const params = useParams();
  useEffect(() => {
    const triggerFullScreen = () => {
      goFullScreen(document.documentElement);
      // Clean up the event listener after fullscreen
      window.removeEventListener('click', triggerFullScreen);
    };

    // Simulate user interaction by adding a click listener
    window.addEventListener('click', triggerFullScreen);

    return () => {
      window.removeEventListener('click', triggerFullScreen);
    };
  }, []);
  useEffect(() => {
    setLoading(true);
    const userAgent = navigator.userAgent;
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)) {
      setDevice(true);
    } else {
      setDevice(false);
    }
    let data = JSON.parse(atob(params.id));
    console.log("data===", data)
    getLogo({ id: data?.organization }).then(res => {
      setLogo(res?.data?.result?.logo)
      setorganizationName(res?.data?.result?.organizationName)
      setCandidateLogo(res?.data?.result?.logo)
      form.setFieldsValue({ email: data?.Email });
      setLoading(false);
    }).catch(err => { console.log("err ===>", err) })
    // try {
    //   form.setFieldsValue({ email: atob(params.id) });
    // } catch (err) {
    //   navigate(routes.test.validurl);
    // }
  }, []);
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // Esc key
        event.preventDefault();
      }
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key.toLowerCase() === 'r' ||
          event.key.toLowerCase() === 'c' ||
          event.key.toLowerCase() === 's' ||
          event.key.toLowerCase() === 'x' ||
          event.key.toLowerCase() === 'n' ||
          event.key.toLowerCase() === 'f' ||
          event.key.toLowerCase() === 'tab')
      ) {
        event.preventDefault();
        console.log('prevent the tab and copy shortcut');
      }
      if (event?.altKey) {
        event.preventDefault();
        console.log('prevent shift and alt key');
      }
      if (
        event.key &&
        event.key.startsWith('F') &&
        !isNaN(event.key.slice(1))
      ) {
        event.preventDefault();
        console.log('Function key press prevented');
      }
    };
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        console.log('visible');
      } else {
        console.log('hidden');
      }
    });
    const handleContextMenu = (event) => {
      event.preventDefault();
      console.log('Right-click context menu prevented');
    };
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);
  const handleVarify = (val) => {
    if (!captchaValue) {
      message.warning("Please complete the reCAPTCHA before proceeding.");
      return;
    }
    goFullScreen(document.documentElement);
     let data = JSON.parse(atob(params.id));
    otpVarify({...val,testID:data?.testID}).then(res => {
      localStorage.setItem('candidate_Email', data?.Email)
      setCandidateToken(res?.data?.token);
      message.success(res?.data?.message);
      navigate(routes.test.welcome)
    }).catch(err => message.error(err?.response?.data?.message))
  };
  const handleCaptchaChange = (value) => {
    console.log("Captcha value:", value);
    setCaptchaValue(value); // you’ll send this to backend for verification
  };
  return (
    <Spin spinning={loading}>
      <Layout className='w-100 h-100 cadidate-login custom-font-family-poppins'>
        <Header className='bg-white border-2 border-bottom border-color h-auto pt-2 pb-2 header-container'>
          <Image src={logo} className='logo' width={120} alt='' preview={false} />
        </Header>
        <Content className='h-100 w-100 bg-white'>
          <div className='w-100 d-flex flex-column justify-content-center align-items-center text-center mt-5 gap-5'>
            <div className='d-flex flex-column lh-base'>
              <span className='welcome-text text-color-custom fw-bold'>
                Welcome to {organizationName}
              </span>
              <span className='welcome-child-text fw-semibold'>
                Assess Your Tech Abilities
              </span>
            </div>
            <Card className='login-card border-0'>
              <span className='fw-bold login-form-title mb-2'>Test Login</span>
              <Form
                form={form}
                onFinish={(val) => {
                  handleVarify(val);
                }}
                className='text-start d-flex flex-column mt-4'
              >
                <Row justify={'center'}>
                  <Col span={24}>
                    <Form.Item
                      name={'email'}
                      rules={[
                        {
                          required: true,
                          message: 'Enter you Email',
                        },
                        {
                          // eslint-disable-next-line
                          pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
                          message: 'Enter Vaild Email',
                        },
                      ]}
                    >
                      <Input
                        placeholder='Email'
                        size='large'
                        disabled={true}
                        className='custom-font-family-poppins'
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name={'otp'}
                      rules={[
                        {
                          required: true,
                          message: 'Enter you OTP',
                        },
                        {
                          pattern: /^\S*$/,
                          message: 'Password must not contain spaces',
                        }
                      ]}
                    >
                      <Input
                        placeholder='OTP'
                        maxLength={6}
                        minLength={6}
                        size='large'
                        onKeyPress={(event) => enterOnlyNumber(event)}
                        className='custom-font-family-poppins'
                      // addonAfter={<div style={{ cursor: 'pointer' }}>Resend Otp</div>}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24} className='d-flex justify-content-center'>
                    <ReCAPTCHA
                      sitekey={site_key}
                      onChange={handleCaptchaChange}
                    />
                  </Col>

                  <Col span={20}>
                    <Form.Item>
                      <div className='w-100 d-flex justify-content-center mt-3'>
                        <Button
                          type='primary'
                          size='large'
                          className=' w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn custom-font-family-poppins'
                          htmlType='submit'
                        >
                          Get Started <RightOutlined />
                        </Button>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </Content>
      </Layout>
      <Modal open={device} closable={false} footer={false}>
        <div>
          <p>Use Desktop or Tablet for better experience. Mobile access is not allowed for the test.</p>
        </div>
      </Modal>
    </Spin>
  );
};

export default CandidateLogin;

{
  /* <Form
form={form}
onFinish={(val) => {
  handleVarify(val);
}}
className='text-start'
>
<Form.Item
  name={'email'}
  rules={[
    {
      required: true,
      message: 'Enter you Email',
    },
    {
      pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
      message: 'Enter Vaild Email',
    },
  ]}
>
  <Input placeholder='Email' disabled={true} />
</Form.Item>
<Form.Item
  name={'otp'}
  rules={[
    {
      required: true,
      message: 'Enter you OTP',
    },
  ]}
>
  <Input
    placeholder='OTP'
    maxLength={6}
    minLength={6}
    onKeyPress={(event) => enterOnlyNumber(event)}
    // addonAfter={<div style={{ cursor: 'pointer' }}>Resend Otp</div>}
  />
</Form.Item>
<Form.Item>
  <Button
    type='primary'
    className=' w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
    htmlType='submit'
  >
    Verify OTP
  </Button>
</Form.Item>
</Form> */
}
